"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilter = void 0;
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
require("react-multi-carousel/lib/styles.css");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const globalVariables_1 = require("../../globalVariables");
const DateFilterList = styled_components_1.default.div `
  background-color: #fafafa;

  .carousel-wrapper {
    position: inherit;
    height: 100%;
    text-align: center;

    .react-multiple-carousel__arrow {
      display: none;
      min-width: 28px;
      min-height: 28px;
      padding: 0;

      @media (min-width: 480px) {
        display: block;
      }

      @media (min-width: 767px) {
        min-width: 30px;
        min-height: 30px;
      }

      &:before {
        font-size: 16px;

        @media (min-width: 767px) {
          font-size: 20px;
        }
      }

      &--left,
      &--right {
        background-color: ${(props) => props.theme.palette.mainAppColor.light};

        &:before {
          color: ${(props) => props.theme.palette.mainAppColor.main};
          font-weight: 700;
        }
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
      }

      &--left {
        left: 5px;

        @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
          left: 0;
        }
      }

      &--right {
        right: 5px;

        @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
          right: 0;
        }
      }
    }
  }
`;
const DateFilterListItem = styled_components_1.default.div `
  cursor: pointer;
  width: 100% !important;
  padding-bottom: 10px;
  padding-top: 10px;

  .MuiTypography-button {
    font-weight: 400;

     @media (max-width: 470px) {
        font-size: 12px;
      }
  }

  &.active {
    font-weight: bold;
    border-bottom: solid 2px
      ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.dark : "#000"};
    color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.dark : "#000"};

    .MuiTypography-button {
      font-weight: 500;
    }
  }
`;
const DateFilter = (props) => {
    const { numberOfDays, timezone, newActivitiesDateUpdate, currentLocale } = props;
    const [dateFilters, setDateFilters] = (0, react_1.useState)([]);
    const [selectedDateFilter, setSelectedDateFilter] = (0, react_1.useState)({
        name: i18n_js_1.default.t("dictionary.dates.today"),
        date: new Date(),
        index: 0,
    });
    const [windowWidth, setWindowWidth] = (0, react_1.useState)(window.innerWidth);
    const [dateWasSelected, setDateWasSelected] = (0, react_1.useState)(false);
    const [isMoving, setIsMoving] = (0, react_1.useState)(false);
    const today = new Date();
    const responsiveCarousel = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 2,
        },
        tablet: {
            breakpoint: { max: 1023, min: 768 },
            items: 3,
            slidesToSlide: 2,
        },
        mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 3,
            slidesToSlide: 1,
            // partialVisibilityGutter: 30,
        },
    };
    const handleDateClick = (dateFilter) => {
        setSelectedDateFilter(dateFilter);
        setDateWasSelected(true);
        if (newActivitiesDateUpdate) {
            if (selectedDateFilter.index === dateFilter.index && dateWasSelected) {
                newActivitiesDateUpdate(null);
                setDateWasSelected(false);
                return;
            }
            newActivitiesDateUpdate(dateFilter);
            return;
        }
        if (props.setUserScrolledToDate) {
            props.setUserScrolledToDate(helpers_1.Helpers.convertDateToTimezone(dateFilter.date.toString(), timezone, {
                dateStyle: "short",
            }));
        }
        props.filterActivitiesByDate(dateFilter);
    };
    const generateDateFilters = () => {
        const filters = new Array(numberOfDays).fill(today).map((date, index) => {
            if (index === 0) {
                return selectedDateFilter;
            }
            if (index === 1) {
                return {
                    name: i18n_js_1.default.t("dictionary.dates.tomorrow"),
                    date: new Date(date.setDate(today.getDate() + 1)),
                    index,
                };
            }
            const nextDay = new Date(date.setDate(today.getDate() + 1));
            return {
                name: helpers_1.Helpers.convertDateToTimezone(nextDay.toString(), timezone, {
                    weekday: "short",
                }),
                date: nextDay,
                index,
            };
        });
        setDateFilters(filters);
    };
    const updateWindowWidth = () => {
        const body = document.querySelector("body");
        if (body) {
            // selecting the body's width instead of window.innerheight because on rezise window.innerheight sometimes has a wrong value in chrome
            setWindowWidth(body.clientWidth);
        }
    };
    (0, react_1.useEffect)(() => {
        generateDateFilters();
        window.addEventListener("resize", updateWindowWidth);
        return () => {
            window.removeEventListener("resize", updateWindowWidth);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (newActivitiesDateUpdate) {
            generateDateFilters();
        }
    }, [numberOfDays]);
    (0, react_1.useEffect)(() => {
        if (newActivitiesDateUpdate) {
            return;
        }
        adjustScrolling(selectedDateFilter, windowWidth);
    }, [selectedDateFilter]);
    (0, react_1.useEffect)(() => {
        adjustScrolling(selectedDateFilter, windowWidth);
    }, [windowWidth]);
    (0, react_1.useEffect)(() => {
        dateFilters.map((dateFilter) => {
            if (props.userScrolledToDate ===
                helpers_1.Helpers.convertDateToTimezone(dateFilter.date.toString(), timezone, {
                    dateStyle: "short",
                })) {
                setSelectedDateFilter(dateFilter);
            }
            return false;
        });
    }, [props.userScrolledToDate]);
    const listStyle = {
        paddingLeft: windowWidth / 3,
        paddingRight: windowWidth / 3,
    };
    const listElementStyle = { width: windowWidth / 3 };
    const renderDateFilterItem = (dates) => dates.map((dateFilter, index) => {
        const activeClass = getActiveClass({
            newActivitiesDateUpdate,
            dateWasSelected,
            dateFilter,
            selectedDateFilter,
        });
        return (react_1.default.createElement(DateFilterListItem, { onClick: (e) => {
                if (isMoving) {
                    return e.preventDefault();
                }
                return handleDateClick(dateFilter);
            }, key: (0, react_uid_1.uid)(dateFilter), className: `date ${activeClass}`, style: listElementStyle, id: `aqa_activities_date_picker_${index}` },
            react_1.default.createElement(Typography_1.default, { variant: "button" }, getDisplayDate(dateFilter, timezone))));
    });
    return (react_1.default.createElement(DateFilterList, { className: "date-filter-list", "data-testid": "date-filter-list", style: listStyle },
        react_1.default.createElement(react_multi_carousel_1.default, { partialVisible: true, minimumTouchDrag: 5, className: "list-items", swipeable: true, draggable: true, responsive: responsiveCarousel, arrows: true, keyBoardControl: true, containerClass: "carousel-wrapper", centerMode: false, beforeChange: () => setIsMoving(true), afterChange: () => setIsMoving(false) }, renderDateFilterItem(dateFilters))));
};
exports.DateFilter = DateFilter;
const mapStoreToProps = (store) => ({
    timezone: store.getValue("timezone"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.DateFilter);
function getActiveClass({ newActivitiesDateUpdate, dateWasSelected, dateFilter, selectedDateFilter, }) {
    if (newActivitiesDateUpdate && !dateWasSelected) {
        return "";
    }
    return dateFilter === selectedDateFilter ? "active" : "";
}
function getDisplayDate(dateFilter, timezone) {
    const date = dateFilter.date;
    const dateFormat = {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    };
    const dateFromHelpers = helpers_1.Helpers.getWeekdayDateAndMonth(date, timezone, dateFormat);
    return dateFromHelpers.toUpperCase();
}
function adjustScrolling(dateFilter, windowWidth) {
    const list = document.querySelector(".date-filter-list");
    const elementWidth = Math.floor(windowWidth / 3);
    const scrollValue = elementWidth * dateFilter.index;
    if (list) {
        list.scrollLeft = scrollValue;
    }
}
